/* Included in gulp starter */

function localize(key) {
  const value = window.SnowcubesLocale?.[key];
  return typeof value === 'string' ? value : '';
}

(function () {
  const HOMEPAGE_SECTION_SUFFIXES = [
    "__evergreen_hero",
    "__proof_testimonials",
    "__featured_product_iMwzax",
  ];

  function isHomepage() {
    return window.location.pathname === "/" || window.location.pathname === "";
  }

  function sectionHasStaleMarkup(section) {
    if (!section) return false;
    const text = section.textContent || "";
    return (
      text.includes("Product Title") ||
      section.querySelector('img[src*="Liquid error"]') !== null
    );
  }

  // Repair images whose Liquid src failed to render, by reading the fallback
  // the markup carries on itself.
  //
  // This used to be a hardcoded list keyed on each image's ALT PROSE. Two
  // things went wrong with that, both found on 2026-08-17:
  //   1. Changing a caption silently unhooked the repair for that image — the
  //      selector just stopped matching, nothing errored, and the fallback was
  //      gone until the next Liquid incident would have exposed it.
  //   2. One entry was already dead. It targeted the hero's DEFAULT alt while
  //      templates/index.json had long since overridden it, and it still
  //      pointed at three_slab.jpg after the hero image had changed.
  // The list was also a second source of truth for filenames, duplicated in
  // layout/theme.liquid, and the two drifted independently.
  //
  // Now the markup declares its own fallback in data-sc-repair-src, so there
  // is exactly one place a filename lives and no coupling to copy at all.
  function directImageRepair() {
    document.querySelectorAll("img[data-sc-repair-src]").forEach((image) => {
      const current = image.getAttribute("src") || "";
      if (!current.includes("Liquid error") && !current.includes("invalid url input")) return;
      const src = image.getAttribute("data-sc-repair-src");
      if (!src) return;
      image.setAttribute("src", src);
      // A stale srcset would override the repaired src and undo the fix.
      image.removeAttribute("srcset");
    });
  }

  function replaceSectionFromFreshRender(section) {
    const sectionId = section.id.replace(/^shopify-section-/, "");
    const params = new URLSearchParams();
    params.set("section_id", sectionId);
    params.set("sc_section_repair", Date.now().toString());

    return fetch(`${window.location.pathname}?${params.toString()}`, {
      credentials: "same-origin",
    })
      .then((response) => (response.ok ? response.text() : ""))
      .then((html) => {
        const trimmed = html.trim();
        if (trimmed) {
          section.outerHTML = trimmed;
          return;
        }

        if (sectionId.endsWith("__featured_product_iMwzax")) {
          section.remove();
        }
      });
  }

  function repairStaleHomepageSections() {
    if (!isHomepage()) return;

    const sections = Array.from(
      document.querySelectorAll('[id^="shopify-section-template--"]')
    ).filter((section) =>
      HOMEPAGE_SECTION_SUFFIXES.some((suffix) => section.id.endsWith(suffix))
    );

    sections.forEach((section) => {
      if (
        section.id.endsWith("__featured_product_iMwzax") &&
        sectionHasStaleMarkup(section)
      ) {
        section.style.display = "none";
      }
    });

    const staleSections = sections.filter(sectionHasStaleMarkup);
    if (!staleSections.length) return;

    directImageRepair();

    Promise.allSettled(staleSections.map(replaceSectionFromFreshRender)).then(
      directImageRepair
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", repairStaleHomepageSections, {
      once: true,
    });
  } else {
    repairStaleHomepageSections();
  }

  window.setTimeout(repairStaleHomepageSections, 750);
})();

document.addEventListener("DOMContentLoaded", () => {
  /**
   * Fixes vh unit in touch devices
   *
   * @since   1.0
   */
  const setupVh = () => {
    const setVh = () => {
      // get the viewport height and we multiple it by 1% to get a value for a vh unit
      let vh = window.innerHeight * 0.01;

      // set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty(`--vh`, `${vh}px`);
    };

    setVh();
    window.addEventListener(`resize`, setVh, false);
  };

  /**
   * Chocks away!
   */
  setupVh();
});

/*
@license
  Praise by Commence (https://commence.studio)

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

window.theme = window.theme || {};

theme.config = {
  mqlSmall: false,
  mediaQuerySmall: "screen and (max-width: 749px)",
  isTouch:
    "ontouchstart" in window ||
    (window.DocumentTouch && window.document instanceof DocumentTouch) ||
    window.navigator.maxTouchPoints ||
    window.navigator.msMaxTouchPoints
      ? true
      : false,
  rtl: document.documentElement.getAttribute("dir") === "rtl" ? true : false,
};

theme.Currency = (function () {
  const moneyFormat = "${{amount}}"; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      const centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getBaseUnit(variant) {
    if (!variant) {
      return;
    }

    if (
      !variant.unit_price_measurement ||
      !variant.unit_price_measurement.reference_value
    ) {
      return;
    }

    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
          variant.unit_price_measurement.reference_unit;
  }

  return {
    formatMoney: formatMoney,
    getBaseUnit: getBaseUnit,
  };
})();

// Init section function when it's visible, then disable observer
theme.initWhenVisible = function (options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof options.callback === "function") {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    },
    { rootMargin: `0px 0px ${threshold}px 0px` }
  );

  observer.observe(options.element);
};

(function () {
  // Trigger events when going between breakpoints
  const mql = window.matchMedia(theme.config.mediaQuerySmall);
  theme.config.mqlSmall = mql.matches;
  mql.onchange = (e) => {
    if (e.matches) {
      theme.config.mqlSmall = true;
      document.dispatchEvent(new CustomEvent("matchSmall"));
    } else {
      theme.config.mqlSmall = false;
      document.dispatchEvent(new CustomEvent("unmatchSmall"));
    }
  };

  // Page transition
  window.addEventListener("beforeunload", () => {
    document.body.classList.add("unloading");
  });
  window.addEventListener("DOMContentLoaded", () => {
    document.body.classList.add("loaded");

    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
  window.addEventListener("pageshow", (event) => {
    // Removes unload class when returning to page via history
    if (event.persisted) {
      document.body.classList.remove("unloading");
    }
  });

  // Viewport height
  function viewportHeight() {
    const platform = navigator?.userAgentData?.platform || navigator?.platform;
    if (
      /iPad|iPhone|iPod/.test(platform) ||
      (platform === "MacIntel" && navigator.maxTouchPoints > 1)
    ) {
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    }
    setHeaderBottomPosition();
  }
  window.addEventListener("resize", viewportHeight);
  window.addEventListener("DOMContentLoaded", viewportHeight);

  if (document.body.getAttribute("data-page-rendering") !== null) {
    // Improve initial load time by skipping the rendering of offscreen content
    const observer = new IntersectionObserver(
      (entries, _observer) => {
        entries.forEach((entry) => {
          const el = entry.target;
          // Not currently in intersection area.
          if (entry.intersectionRatio == 0) {
            return;
          }
          // Trigger rendering for elements within scroll area that haven't already been marked.
          if (!el.markedVisible) {
            el.attributeStyleMap &&
              el.attributeStyleMap.set("content-visibility", "visible");
            el.markedVisible = true;
          }
        });
      },
      // Set a rendering 50px above and 100px below the main scroll area.
      { rootMargin: "50px 0px 100px 0px" }
    );
    const sections = document.querySelectorAll(
      ".shopify-section + .shopify-section"
    );
    sections.forEach((section) => {
      observer.observe(section);
    });
  }

  /*
  // Delay JavaScript until user interaction
  const loadScriptsTimer = setTimeout(loadScripts, 5000);
  const userInteractionEvents = ["mouseover", "mousemove", "keydown", "touchstart", "touchend", "touchmove", "wheel"];
  userInteractionEvents.forEach(function(event) {
    window.addEventListener(event, triggerScriptLoader, {
      passive: !0
    });
  });
  function triggerScriptLoader() {
    loadScripts();
    clearTimeout(loadScriptsTimer);
    userInteractionEvents.forEach(function(event) {
      window.removeEventListener(event, triggerScriptLoader, {
        passive: !0
      });
    });
  }
  function loadScripts() {
    document.querySelectorAll("script[data-type='lazy']").forEach(function(script) {
      script.setAttribute("src", script.getAttribute("data-src"));
    });
  }
  */
})();

// Prevent vertical scroll while using flickity sliders
(function () {
  var e = !1;
  var t;

  document.body.addEventListener("touchstart", function (i) {
    if (!i.target.closest(".flickity-slider")) {
      return (e = !1);
    }
    e = !0;
    t = {
      x: i.touches[0].pageX,
      y: i.touches[0].pageY,
    };
  });

  document.body.addEventListener(
    "touchmove",
    function (i) {
      if (e && i.cancelable) {
        var n = {
          x: i.touches[0].pageX - t.x,
          y: i.touches[0].pageY - t.y,
        };
        Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault();
      }
    },
    { passive: !1 }
  );
})();

/* Overflow Slider Logic */
///////////////////////////////
///////////////////////////////

class OverflowSlider extends HTMLElement {
  constructor() {
    super();

    this.slider = this;
    this.sliderContainer = this.querySelector(".overflow-slider__container");
    this.prevArrow = this.querySelector(".overflow-slider__arrow.prev");
    this.nextArrow = this.querySelector(".overflow-slider__arrow.next");
    if (!this.prevArrow || !this.nextArrow) return;

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600,
    });
  }

  init() {
    [this.prevArrow, this.nextArrow].forEach((arrow) => {
      arrow.addEventListener("click", () => {
        this.moveSlide(arrow.classList.contains("prev"));
      });
    });

    this.sliderContainer.addEventListener("scroll", () => {
      this.updateArrowState();
    });

    this.updateArrowState();
  }

  updateArrowState() {
    var maxScrollLeft =
      this.sliderContainer.scrollWidth - this.sliderContainer.clientWidth;
    var scrollPercentage =
      maxScrollLeft > 0
        ? (this.sliderContainer.scrollLeft / maxScrollLeft) * 100
        : 100;
    var hidePrev = maxScrollLeft <= 0 || scrollPercentage <= 2;
    var hideNext = maxScrollLeft <= 0 || scrollPercentage >= 98;

    this.setArrowState(this.prevArrow, hidePrev);
    this.setArrowState(this.nextArrow, hideNext);
  }

  setArrowState(arrow, isDisabled) {
    arrow.classList.toggle("disabled", isDisabled);
    arrow.disabled = isDisabled;

    if (isDisabled) {
      arrow.setAttribute("aria-disabled", "true");
    } else {
      arrow.removeAttribute("aria-disabled");
    }
  }

  moveSlide(prevPressed) {
    var slideWidth =
      this.sliderContainer.querySelector("*:not(link)").offsetWidth +
      this.sliderContainer.scrollLeft;
    var direction = prevPressed ? -1 : 1;
    var endPos = slideWidth * direction;
    this.sliderContainer.scrollLeft = endPos;
  }
}
customElements.define("overflow-slider", OverflowSlider);

/* Text Area Counter */
///////////////////////////////
///////////////////////////////

class TextareaCounter extends HTMLElement {
  constructor() {
    super();
    this.textarea = this.querySelector("textarea");
    this.current = this.querySelector(".textarea-counter__count__current");
    this.count = 1;

    if (!this.textarea || !this.current) return;
  }

  connectedCallback() {
    this.addEventListener("keyup", this.updateCount, true);
  }

  updateCount(e) {
    this.count = this.textarea.value.length;
    this.updateNumber();
  }

  updateNumber() {
    this.current.innerHTML = this.count;
  }
}
customElements.define("textarea-counter", TextareaCounter);

/* Number Input */
///////////////////////////////
///////////////////////////////

//Includes Cart Functionality

class NumberInput extends HTMLElement {
  constructor() {
    super();
    this.increment = this.querySelector(".increment");
    this.decrement = this.querySelector(".decrement");
    this.input = this.querySelector("input[type='number']");
    this.min = this.input.getAttribute("min");
    const key = this.closest('number-input').getAttribute('data-key');
    const lineVal = this.closest('number-input').getAttribute('line');

      if (!this.increment || !this.decrement || !this.input) return;

    // Set the debounce delay (in milliseconds)
     const debounceDelay = 300;
    
     // Create a debounced version of the changeItemQuantity function
    this.debouncedChangeItemQuantity = debounce(
      (key, quantity, lineVal, analyticsContext) =>
        this.changeItemQuantity(key, quantity, lineVal, analyticsContext),
      debounceDelay
    );

    // Attach immediate input value update and debounced function
    this.increment.addEventListener("click", (event) => {
      event.preventDefault();
      const oldQuantity = parseInt(this.input.value, 10) || 0;
      this.input.value = oldQuantity + 1;
      this.debouncedChangeItemQuantity(key, this.input.value, lineVal, {
        action: 'increment',
        oldQuantity,
      });
    });

    // Explicit remove. Setting the quantity to 0 is what Shopify treats as a
    // line removal, and it is what decrementing to zero already did — this just
    // makes it reachable in one labelled press instead of N unlabelled ones.
    // Routed through the same debounced handler so re-render, analytics and
    // error handling are not duplicated.
    this.remove = this.querySelector(".number-input__remove");
    if (this.remove) {
      this.remove.addEventListener("click", (event) => {
        event.preventDefault();
        const oldQuantity = parseInt(this.input.value, 10) || 0;
        this.input.value = 0;
        this.debouncedChangeItemQuantity(key, 0, lineVal, {
          action: 'remove',
          oldQuantity,
        });
      });
    }

    this.decrement.addEventListener("click", (event) => {
      event.preventDefault();
      // `this.min` is the `min` ATTRIBUTE — a string ("1") or null, never
      // undefined. The old `parseInt(value) !== this.min` compared a NUMBER to a
      // STRING with `!==`, which is ALWAYS true, so the floor never held: the qty
      // could be driven below min — to 0 (removes the line) or negative (Shopify
      // cart error). Compare number-to-number and only step down while above min.
      const minNum = this.min == null ? null : parseInt(this.min, 10);
      const oldQuantity = parseInt(this.input.value, 10) || 0;
      if (minNum === null || Number.isNaN(minNum) || oldQuantity > minNum) {
        this.input.value = oldQuantity - 1;
        this.debouncedChangeItemQuantity(key, this.input.value, lineVal, {
          action: 'decrement',
          oldQuantity,
        });
      }
    });
  }

  
 getSectionsToRender() {
     return [
      {
        id: 'main-cart',
        selector: '#Main-cart-items'
        },
      {
        id: 'header',
        selector: '#cart-drawer--relative'
       },
      {
        id: 'header',
        selector: '#cart-drawer--sticky'
       },
      {
        id: 'header',
        selector: '#cart-details--relative'
       },
      {
        id: 'header',
        selector: '#cart-details--sticky'
      }
    ];
  }
  
  getSectionInnerHTML(html, selector) {
    if (typeof html !== 'string' || !html.trim() || !selector) return null;

    const section = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
    return section ? section.innerHTML : null;
  }

  trackQuantityResult(eventKey, analyticsContext, requestedQuantity, properties = {}) {
    const analytics = window.SnowcubesAnalytics;
    const eventName = analytics?.EVENTS?.[eventKey];
    if (!eventName || typeof analytics?.track !== 'function') return;

    analytics.track(eventName, {
      action: analyticsContext?.action || 'direct',
      old_quantity: Number.isFinite(analyticsContext?.oldQuantity)
        ? analyticsContext.oldQuantity
        : null,
      requested_quantity: parseInt(requestedQuantity, 10),
      ...properties,
    });
  }

  // The ship date belongs to the order being built in this cart. Shopify keeps
  // cart attributes after the last line is removed, so announce that the order
  // ended or the next item added inherits its date. The delivery calendar owns
  // ship_date writes and claims the event to order the clear behind any save
  // still in flight; without it on the page, clear here. Only ship_date is
  // sent, so the note and other attributes stay, and the removal, which already
  // succeeded and rendered, never waits on or fails with the clear.
  endShipDate(cart) {
    const shipDate = cart.attributes?.ship_date || '';
    const ended = new CustomEvent('cart:emptied', { cancelable: true, detail: { shipDate, token: cart.token } });
    const key = 'snowcubes:ship-date-reset';
    const saveKey = 'snowcubes:ship-date-save';
    let previous = window.__snowcubesShipDateReset;
    if (!previous) {
      try {
        const saved = JSON.parse(sessionStorage.getItem(key) || sessionStorage.getItem(saveKey));
        if (saved?.token === cart.token && saved.indeterminate) previous = { ...saved, pending: true, orphaned: true };
      } catch (_error) { /* Preserve the available in-page state. */ }
    }
    // The order ended even if its last pick never reached the cart. Preserve
    // any remote-write uncertainty above before discarding that pick's intent.
    try { sessionStorage.removeItem(saveKey); } catch (_error) { /* Storage may be unavailable. */ }
    if (!shipDate && !previous?.pending) {
      document.dispatchEvent(ended);
      return;
    }
    const reset = previous?.pending && previous.token === cart.token
      ? previous : { token: cart.token || '', pending: true, indeterminate: false };
    reset.ended = true;
    reset.emptyCart = true;
    reset.value = '';
    reset.holdUntil ||= Date.now() + 30000;
    window.__snowcubesShipDateReset = reset;
    const persist = () => {
      try {
        sessionStorage.removeItem(saveKey);
        if (reset.pending && reset.token) {
          sessionStorage.setItem(key, JSON.stringify({ token: reset.token, indeterminate: Boolean(reset.indeterminate || reset.flight), holdUntil: reset.holdUntil }));
        } else sessionStorage.removeItem(key);
      } catch (_error) { /* Keep the in-page hold when storage is denied. */ }
    };
    persist();
    if (!document.dispatchEvent(ended)) return;
    const warn = () => {
      reset.failed = true;
      const message = window.cartStrings?.error || localize('sections.cart.cart_error');
      document.querySelectorAll('.Cart-Errors').forEach((node) => {
        if (!node.textContent || node.dataset.shipDateResetError === node.textContent) {
          node.textContent = message;
          node.dataset.shipDateResetError = message;
        }
      });
    };
    const scheduleRecovery = () => {
      if (reset.recoveryTimer) return;
      reset.holdUntil ||= Date.now() + 30000;
      reset.recoveryTimer = setTimeout(() => reset.recover(), Math.max(0, reset.holdUntil - Date.now()));
      persist();
    };
    const request = async (url, init, readBody = false) => {
      const controller = new AbortController();
      let expired = false;
      let timer;
      const operation = Promise.resolve().then(async () => {
        const response = await fetch(url, { ...init, signal: controller.signal });
        if (!response.ok) return { outcome: 'failed' };
        return { outcome: 'saved', cart: readBody ? await response.json() : null };
      });
      if (!readBody) {
        reset.flight = operation;
        operation.then(() => {
          // Even a response arriving after the grace period can be an old write.
          // The current owner must reassert its latest intent in that case.
          if (expired && window.__snowcubesShipDateReset === reset) reset.recover();
        }, () => { /* Rejection is recovered at the same bounded deadline. */ });
        persist();
      }
      try {
        return await Promise.race([operation, new Promise((resolve) => {
          timer = setTimeout(() => {
            expired = true;
            resolve({ outcome: 'indeterminate' });
            controller.abort();
          }, 5000);
        })]);
      } catch (_error) {
        return { outcome: 'indeterminate' };
      } finally {
        clearTimeout(timer);
      }
    };
    persist(); // Retain only the cart token and uncertainty, before sending.
    const clear = async () => {
      for (let attempt = 1; attempt <= 3; attempt += 1) {
        const identity = await request(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' }, true);
        if (identity.outcome !== 'saved' || !identity.cart?.token) { warn(); return; }
        if (identity.cart.token !== reset.token) {
          if (window.__snowcubesShipDateReset === reset) {
            window.__snowcubesShipDateReset = { token: identity.cart.token, pending: false, ended: false, verified: true };
            try { sessionStorage.removeItem(key); } catch (_error) { /* The in-page state is current. */ }
          }
          return;
        }
        const result = await request(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { ship_date: '' } }),
        });
        if (result.outcome === 'indeterminate') {
          reset.indeterminate = true;
          persist();
          warn();
          return;
        }
        reset.flight = null;
        persist();
        if (result.outcome === 'saved') {
          const readback = await request(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' }, true);
          reset.flight = null;
          if (readback.outcome === 'saved' && readback.cart?.token === reset.token && readback.cart.attributes && typeof readback.cart.attributes === 'object' && !Array.isArray(readback.cart.attributes) && !readback.cart.attributes.ship_date) {
            reset.pending = false;
            reset.failed = false;
            reset.indeterminate = false;
            reset.holdUntil = 0;
            clearTimeout(reset.recoveryTimer);
            reset.recoveryTimer = null;
            persist();
            document.querySelectorAll('.Cart-Errors').forEach((node) => {
              if (node.dataset.shipDateResetError === node.textContent) {
                node.textContent = '';
                delete node.dataset.shipDateResetError;
              }
            });
            return;
          }
          warn();
          return;
        }
        if (attempt < 3) await new Promise((resolve) => setTimeout(resolve, 1000 * Math.pow(2, attempt - 1)));
      }
      warn();
    };
    reset.recover = () => {
      if (window.__snowcubesShipDateReset !== reset) return;
      clearTimeout(reset.recoveryTimer);
      reset.recoveryTimer = null;
      // A retry can still be finishing at the grace deadline. Keep its custody
      // until it settles so an older clear cannot overtake a newer calendar pick.
      if (reset.cleanup) {
        reset.cleanup.then(() => {
          if (reset.pending && window.__snowcubesShipDateReset === reset) reset.recover();
        });
        return;
      }
      reset.holdUntil = 0;
      reset.orphaned = false;
      reset.flight = null;
      reset.indeterminate = false;
      reset.pending = true;
      scheduleRecovery();
      reset.cleanup = clear().finally(() => { reset.cleanup = null; });
    };
    scheduleRecovery();
    if (reset.orphaned || reset.flight || reset.cleanup) {
      persist();
      warn();
      return;
    }
    reset.cleanup = clear().finally(() => { reset.cleanup = null; });
  }

  async changeItemQuantity(key, quantity, line, analyticsContext = {}) {
    const startedAt = typeof performance?.now === 'function'
      ? performance.now()
      : Date.now();
    const elapsedMs = () => Math.max(0, Math.round(
      (typeof performance?.now === 'function' ? performance.now() : Date.now()) - startedAt
    ));
    let formData = {
      id: key,
      quantity: quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    };

    const lineError = this.nextElementSibling;
    const smallElement = lineError.querySelector('small');   

    // Put the stepper back on what the cart really holds: the input's `value`
    // attribute is the server-rendered quantity, not the one just typed or clicked.
    const resetQuantityInputs = () => {
      document.querySelectorAll(`#Cart-Quantity-${line}`).forEach((input) => {
        input.value = input.getAttribute('value');
        input.dispatchEvent(new Event('input'));
      });
    };

    // Preserve existing line item properties (gift note, flavor, etc.)
    try {
      const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        const item = cart.items?.find((entry) => entry.key === key);
        if (item?.properties && Object.keys(item.properties).length > 0) {
          formData = { ...formData, properties: item.properties };
        }
      }
    } catch (error) {
      // Non-blocking: continue without properties if cart lookup fails.
    }

    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        if (!parsedState.items) {
          resetQuantityInputs();
          // Shopify's `message` is the generic "Cart Error"; the reason is in `description`.
          smallElement.innerText = parsedState.description
            || window.cartStrings?.error
            || localize('sections.cart.cart_error');
          this.trackQuantityResult(
            'CART_QUANTITY_UPDATE_FAILED',
            analyticsContext,
            quantity,
            {
              failure_class: 'shopify_rejected',
              latency_ms: elapsedMs(),
            }
          );
          return;
        }

        const committedItem = parsedState.items.find((entry) => entry.key === key);
        this.trackQuantityResult(
          'CART_QUANTITY_UPDATE',
          analyticsContext,
          quantity,
          {
            committed_quantity: committedItem?.quantity ?? parseInt(quantity, 10),
            latency_ms: elapsedMs(),
          }
        );

        const renderedSections = parsedState.sections && typeof parsedState.sections === 'object'
          ? parsedState.sections
          : {};

        this.getSectionsToRender().forEach((section) => {
          let elementToReplace = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          const cartDrawer =  document.querySelector('[data-section="cart-drawer"]');

          if ((section.selector == '#cart-drawer--sticky' || section.selector == '#cart-drawer--relative') && cartDrawer){
            elementToReplace = cartDrawer;
          }

          if (elementToReplace) {
            if (elementToReplace == cartDrawer){
              const cartDrawerHtml = renderedSections['main-cart'];
              if (typeof cartDrawerHtml === 'string') {
                cartDrawer.innerHTML = cartDrawerHtml;
              }
            }
            else{
              const sectionHtml = this.getSectionInnerHTML(
                renderedSections[section.id],
                section.selector
              );
              if (sectionHtml !== null) {
                elementToReplace.innerHTML = sectionHtml;
              }
            }
           } 
        });

        // Re-render gift summaries after cart drawer updates.
        const updatedCartDrawer = document.querySelector('[data-section="cart-drawer"]');
        if (updatedCartDrawer && window.SnowcubesGift?.renderGiftSummaries) {
          window.SnowcubesGift.renderGiftSummaries(updatedCartDrawer);
        }

        if (parsedState.items.length === 0) {
          this.endShipDate(parsedState);
        }
      })
      .catch((e) => {
        resetQuantityInputs();
        const errors = document.querySelectorAll('.Cart-Errors');
        const message = window.cartStrings?.error || localize('sections.cart.cart_error');
        errors.forEach(errorNode => {
          errorNode.innerText = message;
        });
        this.trackQuantityResult(
          'CART_QUANTITY_UPDATE_FAILED',
          analyticsContext,
          quantity,
          {
            failure_class: 'request_error',
            latency_ms: elapsedMs(),
          }
        );
    });
  }
}
customElements.define("number-input", NumberInput);

/* Copy Input Text */
///////////////////////////////
///////////////////////////////

class CopyInputText extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
    this.input = this.querySelector("input");

    if (!this.button || !this.input) return;
    this.button.addEventListener("click", this.copy.bind(this));
  }

  copy() {
    this.input.select();
    this.input.setSelectionRange(0, 99999); // For mobile devices

    // Copy the text inside the text field
    navigator.clipboard.writeText(this.input.value);

    // Alert the copied text
    alert(localize('gift_cards.issued.copy_success'));
  }
}
customElements.define("copy-input-text", CopyInputText);

/* Logic the Shopify Starter Included */
////////////////////////////////////////
///////////////////////////////////////

// document.querySelectorAll(".disclosure").forEach((details) => {
//   const summary = details.querySelector("summary");
//   const cancel = details.querySelector('button[type="reset"]');

//   summary.setAttribute(
//     "aria-expanded",
//     summary.parentElement.hasAttribute("open")
//   );

//   summary.addEventListener("click", () => {
//     summary.setAttribute("aria-expanded", !details.hasAttribute("open"));
//   });

//   cancel &&
//     cancel.addEventListener("click", () => {
//       details.removeAttribute("open");
//       summary.setAttribute("aria-expanded", "false");
//     });
// });

const DIALOG_ESCAPE_HANDLER_PROPERTY = "__snowcubesDialogEscapeHandler";
const DIALOG_EXPANDED_STATE_BOUND_PROPERTY = "__snowcubesDialogExpandedStateBound";
const DIALOG_EXPANDED_STATE_OBSERVER_PROPERTY = "__snowcubesDialogExpandedStateObserver";

function syncDialogExpandedState(dialog) {
  if (
    !dialog ||
    typeof dialog.matches !== "function" ||
    !dialog.matches("details.dialog")
  ) {
    return;
  }

  const summary = dialog.querySelector("summary");
  if (!summary) return;

  summary.setAttribute("aria-expanded", dialog.hasAttribute("open") ? "true" : "false");
}

function bindDialogExpandedState(dialog) {
  if (!dialog || dialog[DIALOG_EXPANDED_STATE_BOUND_PROPERTY]) return;

  dialog[DIALOG_EXPANDED_STATE_BOUND_PROPERTY] = true;
  syncDialogExpandedState(dialog);
  dialog.addEventListener("toggle", () => syncDialogExpandedState(dialog));
}

function setupDialogExpandedState() {
  if (document[DIALOG_EXPANDED_STATE_OBSERVER_PROPERTY]) return;

  const bindDialogs = (root) => {
    if (!root || typeof root.querySelectorAll !== "function") return;

    if (typeof root.matches === "function" && root.matches("details.dialog")) {
      bindDialogExpandedState(root);
    }

    root.querySelectorAll("details.dialog").forEach(bindDialogExpandedState);
  };

  bindDialogs(document);

  const observer =
    typeof MutationObserver === "function"
      ? new MutationObserver((records) => {
          records.forEach((record) => {
            record.addedNodes.forEach((node) => {
              if (node.nodeType === 1) bindDialogs(node);
            });
          });
        })
      : null;

  if (observer) {
    observer.observe(document.documentElement || document.body || document, {
      childList: true,
      subtree: true,
    });
  }

  document[DIALOG_EXPANDED_STATE_OBSERVER_PROPERTY] = observer || true;
}

setupDialogExpandedState();

function setupDialogEscapeHandling() {
  if (document[DIALOG_ESCAPE_HANDLER_PROPERTY]) return;

  const handleDialogEscape = (event) => {
    if (event.key !== "Escape") return;

    const eventTarget = event.target;
    const activeElement = document.activeElement;
    const dialog = [eventTarget, activeElement]
      .filter((target) => target && typeof target.closest === "function")
      .map((target) => target.closest("details.dialog[open]"))
      .find(Boolean);

    if (!dialog) return;

    const summary = Array.from(dialog.children).find(
      (child) => child.tagName === "SUMMARY"
    ) || dialog.querySelector("summary");

    event.preventDefault();
    dialog.removeAttribute("open");
    if (!summary) return;

    summary.setAttribute("aria-expanded", "false");
    if (typeof summary.focus === "function") {
      summary.focus({ preventScroll: true });
    }
  };

  document.addEventListener("keydown", handleDialogEscape);
  document[DIALOG_ESCAPE_HANDLER_PROPERTY] = handleDialogEscape;
}

setupDialogEscapeHandling();

document.querySelectorAll(".disclosure").forEach((details) => {
  const summary = details.querySelector("summary");
  const dropdownContent = details.querySelector(".disclosure__content");
  const links = details.querySelector('.site-header__dropdown__block__submenu-list');
  const cancel = details.querySelector('button[type="reset"]');

  // Header menus aren't all the same shape — a `.disclosure` may lack a summary,
  // dropdown content, or submenu list. An unguarded null-deref here threw inside
  // forEach and aborted wiring EVERY later menu on the page. Guard each.
  if (!summary) return;

  summary.setAttribute(
    "aria-expanded",
    summary.parentElement.hasAttribute("open")
  );

  if (!summary.classList.contains("open-hover")) {
    summary.addEventListener("click", () => {
      summary.setAttribute("aria-expanded", !details.hasAttribute("open"));
    });

    cancel &&
      cancel.addEventListener("click", () => {
        details.removeAttribute("open");
        summary.setAttribute("aria-expanded", "false");
      });
  }
  else {
    details.addEventListener("mouseenter", () => {
    // Close other open dropdowns
    document.querySelectorAll(".disclosure[open]").forEach((otherDetails) => {
      if (otherDetails !== details) {
        otherDetails.removeAttribute("open");
        otherDetails.querySelector("summary").setAttribute("aria-expanded", "false");
      }
    });

    details.setAttribute("open", "");
    summary.setAttribute("aria-expanded", "true");
  });

  dropdownContent && dropdownContent.addEventListener("mouseleave", (event) => {
    const target = event.relatedTarget;

    if (target && (dropdownContent.contains(target) || (links && links.contains(target)))) {
      // Mouse is leaving the submenu but entering another part of the disclosure or links, don't close
      return;
    }

    details.removeAttribute("open");
    summary.setAttribute("aria-expanded", "false");
  });
  }
});



function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function pauseAllMedia() {
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

/* Supporting Functions from Be Yours Theme */
/////////////////////////////////////////////
/////////////////////////////////////////////

function setHeaderBottomPosition() {
  const header = document.getElementById("shopify-section-header");
  if (header) {
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(header.getBoundingClientRect().bottom)}px`
    );
  }
}

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

//CLOSE MENU SETUP FOR ANCHOR LINKS
const navLinks = document.querySelectorAll('.overlay-nav__plain-link');
const overlay_navs =document.querySelectorAll('.__style-left-drawer');

navLinks.forEach(link=>{
  link.addEventListener("click", function(){
    overlay_navs.forEach(nav => nav.removeAttribute("open"))
  });
})


//Prevent overflow for drawer

// `.__mobile-overflow-none` pins body with `position: fixed` so iOS Safari stops
// scrolling the page behind a drawer, but alone that throws the page to the top.
// The negative `top` keeps the page where it was, and unlock scrolls back there.
// Locks are held per owner: one closing under another neither unlocks the page
// early nor restores a stale offset.
const scrollLockOwners = new Set();
let scrollLockY = 0;

function lockPageScroll(owner) {
  if (scrollLockOwners.has(owner)) return;
  if (scrollLockOwners.size === 0) {
    scrollLockY = window.scrollY;
    document.body.style.top = `-${scrollLockY}px`;
    document.body.classList.add('__mobile-overflow-none');
  }
  scrollLockOwners.add(owner);
}

function unlockPageScroll(owner) {
  if (!scrollLockOwners.delete(owner) || scrollLockOwners.size > 0) return;
  document.body.classList.remove('__mobile-overflow-none');
  document.body.style.top = '';
  window.scrollTo(0, scrollLockY);
}

window.SnowcubesScrollLock = { lock: lockPageScroll, unlock: unlockPageScroll };

// The header renders twice (the second copy is display:none) and add-to-cart
// opens both cart drawers, so the owner is the drawer kind, not the element:
// closing the visible cart must unlock while its hidden twin stays open.
// `toggle` covers summary taps, Escape, add-to-cart and the nav-link close.
const SCROLL_LOCK_DRAWERS = [
  ['menu', 'details.site-header__hamburger'],
  ['cart', 'details[id^="dialog-trigger-cart-"]'],
];

document.addEventListener('toggle', (event) => {
  const drawer = event.target;
  const [owner] = SCROLL_LOCK_DRAWERS.find(([, selector]) => drawer?.matches?.(selector)) || [];
  if (!owner) return;

  if (!drawer.open) unlockPageScroll(owner);
  else if (window.innerWidth <= 1200) lockPageScroll(owner);
}, true);
